<div *ngIf="!uploadDone && uploading" class="upload-container">
    <div class="upload-progress">
        <mat-spinner [diameter]="20" [strokeWidth]="2" color="accent"></mat-spinner>
        {{'UPLOADING' | translate}}...
    </div>
</div>

<div class="mat-table">
    <mat-toolbar class="sc-toolbar" color="primary">
        <div class="title">
            <span>{{'PROCEDURECODES' | translate}}</span>
        </div>

        <span class="fire-spacer"></span>

        <button (click)="uploadFile()" [matTooltip]="'UPLOAD_PROCEDURES' | translate" mat-button>
            <mat-icon class="upload-icon-gradient" fontIcon="mdi-upload" fontSet="mdi"></mat-icon>
        </button>

        <button (click)="deleteAll()" [matTooltip]="'DELETE_ALL' | translate" mat-button>
            <mat-icon class="delete-icon-gradient" fontIcon="mdi-delete" fontSet="mdi"></mat-icon>
        </button>

        <button (click)="exportProcedures()" [matTooltip]="'EXPORT_TO_EXCEL' | translate" mat-button>
            <mat-icon class="excel-icon-gradient" fontIcon="mdi-microsoft-excel" fontSet="mdi"></mat-icon>
        </button>

        <button [matTooltip]="'ADD_NEW' | translate" mat-button (click)="editProcedureCode({})">
            <mat-icon class="add-icon-gradient" fontIcon="mdi-plus-box" fontSet="mdi"></mat-icon>
        </button>
    </mat-toolbar>

    <div class="search-area" fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center"
         style="padding-right: 8px;">
        <mat-form-field floatLabel="never" fxFlex="40%">
            <span matPrefix><mat-icon fontIcon="mdi-magnify" fontSet="mdi" class="prefix-icon" style="top: -3px;"
                                      tabindex="-1"></mat-icon>&nbsp;
            </span>
            <input matInput #filter [placeholder]="'SEARCH' | translate" [autofocus]="true">
        </mat-form-field>

        <mat-spinner *ngIf="isLoadingResults || isRateLimitReached" mode="indeterminate" [strokeWidth]="2"
                     [diameter]="20"></mat-spinner>

    </div>

    <mat-table [dataSource]="dataSource" class="fire-table" [@state]="dataSource.data.length"
               [trackBy]="trackById"
               matSort
               matSortActive="code"
               matSortDirection="asc"
               matSortDisableClear>

        <!--Table-->
        <ng-container *ngFor="let col of displayedColumns" cdkColumnDef="{{col.label}}" [class.hidden]="col.hidden">
            <mat-header-cell *cdkHeaderCellDef [disabled]="!col.sortable" class="fire-header-cell"
                             mat-sort-header="{{col.value}}"> {{col.header | translate}}</mat-header-cell>

            <ng-container>
                <mat-cell *cdkCellDef="let row" class="fire-cell"> {{row[col.label]}}</mat-cell>
            </ng-container>

        </ng-container>

        <!--actions-->
        <ng-container cdkColumnDef="action">
            <mat-header-cell *cdkHeaderCellDef class="fire-header-cell"></mat-header-cell>
            <mat-cell *cdkCellDef="let row" class="fire-cell">
                <button mat-icon-button (click)="$event.stopPropagation(); editProcedureCode(row)">
                    <mat-icon class="edit-icon-gradient" fontIcon="mdi-pencil" fontSet="mdi"></mat-icon>
                </button>
                <button mat-icon-button (click)="$event.stopPropagation(); deleteProcedureCode(row)">
                    <mat-icon class="delete-icon-gradient" fontIcon="mdi-delete" fontSet="mdi"></mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <!--header-->
        <mat-header-row *cdkHeaderRowDef="cols; sticky:true" class="fire-header-row"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: cols;"
                 class="fire-row">
        </mat-row>
    </mat-table>

    <mat-paginator [length]="resultsLength"
                   [pageIndex]="0"
                   [pageSize]="25"
                   [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons>
    </mat-paginator>
</div>


<ng-container *ngIf="downloading">
    <div fxLayout="row" fxLayoutAlign="center center"
         style="position:fixed;top: 0; left: 0;height: 100vh;width: 100vw; background: rgba(0, 0, 0, 0.4);">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px"
             style="height: 86px;width: 360px;border-radius: 8px;background: rgb(255 255 255);color: #585858;">
            <mat-spinner diameter="30" strokeWidth="2"></mat-spinner>
            <h3>{{'EXPORTING' | translate}}</h3>
        </div>
    </div>
</ng-container>
<input #fileInput (change)="onFileChange($event)" id="procedures-file" name="procedures-file"
       style="visibility: hidden; display: none" type="file">